import type { QueryClient } from '@tanstack/react-query';


function invalidateBillingCaches(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ['billing-entries'] });
  queryClient.invalidateQueries({ queryKey: ['billing-entries-review'] });
  queryClient.invalidateQueries({ queryKey: ['billing-entries-list'] });
  queryClient.invalidateQueries({ queryKey: ['billing-summary'] });
  queryClient.invalidateQueries({ queryKey: ['billing-export-entries'] });
  queryClient.invalidateQueries({ queryKey: ['billing-detail'] });
  queryClient.invalidateQueries({ queryKey: ['today-entries'] });
}


export function invalidateExpenseMoveCaches(
  queryClient: QueryClient,
  sourceMatterId: number,
  targetMatterId: number,
  hasLinkedBillingEntry: boolean,
) {
  queryClient.invalidateQueries({ queryKey: ['expenses', sourceMatterId] });
  queryClient.invalidateQueries({ queryKey: ['activities', sourceMatterId] });
  queryClient.invalidateQueries({ queryKey: ['expenses', targetMatterId] });
  queryClient.invalidateQueries({ queryKey: ['activities', targetMatterId] });
  if (hasLinkedBillingEntry) {
    queryClient.invalidateQueries({ queryKey: ['matter-time-entries', sourceMatterId] });
    queryClient.invalidateQueries({ queryKey: ['matter-time-entries', targetMatterId] });
    invalidateBillingCaches(queryClient);
  }
}


export function invalidateTimeEntrySaveCaches(
  queryClient: QueryClient,
  sourceMatterId: number,
  savedMatterId: number,
) {
  queryClient.invalidateQueries({ queryKey: ['matter-time-entries', sourceMatterId] });
  queryClient.invalidateQueries({ queryKey: ['activities', sourceMatterId] });
  if (savedMatterId !== sourceMatterId) {
    queryClient.invalidateQueries({ queryKey: ['matter-time-entries', savedMatterId] });
    queryClient.invalidateQueries({ queryKey: ['activities', savedMatterId] });
  }
  invalidateBillingCaches(queryClient);
  queryClient.invalidateQueries({ queryKey: ['running-timer'] });
}
